import { Component, Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from "../../../_common/_service/user.service";
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-editIdmobilemoneybeneficiari',
  templateUrl: './editIdmobilemoneybeneficiari.component.html',
  styleUrls: ['./editIdmobilemoneybeneficiari.component.scss']
})

export class EditIdMobilemoneybeneficiariComponent implements OnInit {

  submitted = false;
  editIdmobileMoneyBeneficiaryForm: FormGroup;
  currentUser: any;
  token: any;

  loadingspinner: boolean = false;
  editId: any;
  serviceCode: any;
  purposeofremittancelist: any;
  senderSourceOfFundlist: any;
  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService,
    private _service: CommonService) {


    this.editIdmobileMoneyBeneficiaryForm = this.fb.group({
      id: [null],
      beneficiary_fname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_lname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_address: [null, [Validators.required]],
      beneficiary_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(1)]],
      beneficiary_email: [null, [Validators.required, Validators.email]],
      senderSourceOfFund: [null, [Validators.required]],
      purposeofremittance: [null, [Validators.required]]

    })

  }


  ngOnInit(): void {
    ;
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    this.editId = this.route.snapshot.queryParams.editId;
    this.token = this.tokenStorageService.getToken();

    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.BeneficiaryInfoEDITbyId();
      this.getpurposeofremittancelistLN();
      this.getsenderSourceOfFundlistLN();
      //this.getParamValueQueryString();
    }
    else {
      this._service.callMethodOfSecondComponent();
    }
  }

  //getParamValueQueryString() {
  //  ;
  //  const url = window.location.href;

  //  if (url.includes('?')) {
  //    const httpParams = new HttpParams({ fromString: url.split('?')[1] });

  //    this.editId = httpParams.get('editId');
  //  }

  //  if (this.editId != undefined && this.editId != null) {

  //    this.BeneficiaryInfoEDITbyId();

  //  }
  //}

  Back() {
    this.router.navigate(['/TransferToMobileMoney'], { queryParams: { serviceCode: this.serviceCode }, skipLocationChange: true });
  }

  get f() { return this.editIdmobileMoneyBeneficiaryForm.controls; }

  BeneficiaryInfoEDITbyId() {
    ;
    this.loadingspinner = true;
    this.authService.GetMobileMoneyBeneficiaryDetailsbyId(this.editId).subscribe(response => {
      debugger;
      this.loadingspinner = false;
      ////////console.log(response[0]);
      this.f.beneficiary_fname.setValue(response[0].beneficiary_fname);
      this.f.beneficiary_lname.setValue(response[0].beneficiary_lname);
      this.f.beneficiary_address.setValue(response[0].beneficiary_address);
      this.f.beneficiary_phone.setValue(response[0].beneficiary_phone);
      this.f.beneficiary_email.setValue(response[0].beneficiary_email);
      this.f.senderSourceOfFund.setValue(response[0].senderSourceOfFund);
      this.f.purposeofremittance.setValue(response[0].purposeofremittance);


    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }







  editIdmobileMoneyBeneficiary(post: any) {
    //
    this.submitted = true;
    if (this.editIdmobileMoneyBeneficiaryForm.valid) {
      this.loadingspinner = true;
      post.id = parseFloat(this.editId);

      this.authService.editIdmobileMoneyBeneficiary(post, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {

        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.submitted = true;
          this.toastr.success(response.apiMessage, 'Success');
          this.editIdmobileMoneyBeneficiaryForm.reset();
        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }



  getsenderSourceOfFundlistLN() {
    debugger
    this.authService.getsenderSourceOfFundlistLN().subscribe(response => {
      debugger

      this.senderSourceOfFundlist = response.apiData.result.result;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }


  getpurposeofremittancelistLN() {

    this.authService.getpurposeofremittancelistLN().subscribe(response => {

      this.purposeofremittancelist = response.apiData.result.result;

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }



}
